import { T } from '../../styles/theme'

export default function Card({ children, style, ...props }) {
  return (
    <div
      style={{ background: T.card, border: `1px solid ${T.cardB}`, borderRadius: 16, padding: 16, margin: '0 16px 12px', ...style }}
      {...props}
    >
      {children}
    </div>
  )
}
